const ARCHIVE_POSTING = 'avisos/archive/ARCHIVE_POSTING';
const ARCHIVE_POSTING_COMPLETED = 'avisos/archive/ARCHIVE_POSTING_COMPLETED';
const ARCHIVE_POSTING_FAILED = 'avisos/archive/ARCHIVE_POSTING_FAILED';
const RESET_ARCHIVE_POSTING = 'avisos/archive/RESET_ARCHIVE_POSTING';

export { ARCHIVE_POSTING, ARCHIVE_POSTING_COMPLETED, ARCHIVE_POSTING_FAILED, RESET_ARCHIVE_POSTING };
